if (!customElements.get('cc-tabs')) {
  customElements.define(
    'cc-tabs',
    class extends HTMLElement {
      constructor() {
        super();
        this.tabs = [];
        this.panels = [];
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', (e) => this.handleTabClick(e));
          tab.addEventListener('keydown', (e) => this.handleKeydown(e));
        });
      }

      handleTabClick(event) {
        const clickedTab = event.currentTarget;
        this.switchTab(clickedTab);
      }

      handleKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let newIndex;

        switch (event.key) {
          case 'ArrowLeft':
            newIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
            break;
          case 'ArrowRight':
            newIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.tabs[newIndex].focus();
        this.switchTab(this.tabs[newIndex]);
      }

      switchTab(selectedTab) {
        const targetId = selectedTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
        });

        selectedTab.setAttribute('aria-selected', 'true');
        selectedTab.setAttribute('tabindex', '0');

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== targetId;
        });
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
          tab.removeEventListener('keydown', this.handleKeydown);
        });
      }
    }
  );
}
